import React from "react";
import PropTypes from "prop-types";
import { CircularProgress, Button } from "@mui/material";
import { withStyles } from "@mui/styles";

const styles = ({ spacing, palette }) => ({
  progress: {
    color: palette.primary.main,
    position: "absolute",
    top: "50%",
    marginTop: -12,
  },
  hide: {
    opacity: 0,
  },
});

const SubmitButton = ({ isSubmitting, children, classes }) => (
  <div>
    <Button
      type="submit"
      variant="contained"
      color="primary"
      disabled={isSubmitting}
    >
      <span className={isSubmitting ? classes.hide : null}>{children}</span>
      {isSubmitting ? (
        <CircularProgress size={24} className={classes.progress} />
      ) : null}
    </Button>
  </div>
);

SubmitButton.propTypes = {
  isSubmitting: PropTypes.bool,
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SubmitButton);
